import React, { useState, useEffect, createContext, useLayoutEffect } from 'react'
import { PageAlert, notificationToast } from 'components'
import { getAuthHeader } from 'utils/auth'
import { Modal, Input, Icon, Tabs } from 'antd'
import FormFooter from 'views/ScanSettings/components/ScanFilterBar/FormFooter'
import useAxios from 'axios-hooks'
import ApiKeyModal from 'views/UserManagement/ApiKeys/components/ApiKeyModal'
import ApiKeyListTop from 'views/UserManagement/ApiKeys/components/ApiKeyListTop'
import ApiKeyList from 'views/UserManagement/ApiKeys/components/ApiKeyList'

const { TextArea } = Input

function ApiKeys() {
	const [generatedKeyName, setGeneratedKeyName] = useState("")
    const [{keyModalVisible, generatedKeyData}, setKeyModalVisible] = useState(false, "")

	// GET key list
	const [{ data: listKeysResponse, loading: listKeysLoading, error: listKeysError }, getKeys] = useAxios(
        {
		url: '/api-keys',
		method: 'GET',
		headers: getAuthHeader(),
		validateStatus: false
    })
    
    // ADD key
	const [{ data: newKeyData, loading: addingKey, error: addKeyError }, addNewKey] = useAxios(
		{
			url: '/api-keys',
			method: 'POST',
			headers: getAuthHeader(),
			validateStatus: false
		},
        { manual: true }
    )

    // GET generated key
	const [{ data: generatedKey, loading: generatingKey, error: generateKeyError }, generateKey] = useAxios(
		{
			url: '/api-keys/generate',
			method: 'GET',
			headers: getAuthHeader()
		},
        { manual: true }
    )

    // DELETE key
	let [{ data: deletekeyData, loading: deletingKey, error: deleteKeyError }, deleteKey] = useAxios(
		{
			url: '/api-keys',
			method: 'DELETE',
			headers: getAuthHeader(),
			validateStatus: false
		},
		{ manual: true }
	)

    const openNotification = (message, errors) => {
		if (!errors) {
			notificationToast({
				message: 'Success',
				description: message,
				icontype: 'check'
			})
		} else {
			notificationToast({
				message: 'Error',
				description: `${message} ${errors.join()}`,
				icontype: 'close-circle'
			})
		}
    }

    // Delete Key
    const onDelete = key => {
        deleteKey({data: { id: key.id}})
    }

    const onNewKey = () => {
        generateKey()
    }
    
    // close project form
	const closeKeyModal = () => {
		resetModalKeys()
    }

    // New Key
	const addKey = newKey => {
        addNewKey({
            data: {
                name: newKey.name,
                key: newKey.key
            }
        })
		resetModalKeys()
	}

	const handleKeyNameChange = e => {
		setGeneratedKeyName(e.target.value)
	}
	
	const resetModalKeys = () => {
		setKeyModalVisible({keyModalVisible:false,generatedKeyData: ""})
		setGeneratedKeyName("")
	}

    //for opening model after key generation
    useEffect(() => {
        if (generatedKey && generatedKey.key && generatedKey.key.length) {
            setKeyModalVisible({keyModalVisible:true,generatedKeyData:generatedKey.key})
        }
    },  [generatedKey])

    // for key deletion
    useEffect(() => {
		if (deletekeyData && deletekeyData.Errors && deletekeyData.Errors.length) {
            openNotification("Cannot delete key,", deletekeyData.Errors)
        } else if (deletekeyData && deletekeyData.id) {
            openNotification("Key deleted.")
            getKeys()
        }
    },  [deletekeyData])
	
	//for posting new key
	useEffect(() => {
		if (newKeyData && newKeyData.Errors && newKeyData.Errors.length) {
			openNotification("Error adding new key,", newKeyData.Errors)
		} else if (newKeyData && newKeyData.id) {
			openNotification("Key added.")
			getKeys()
		}
	}, [newKeyData])
    
	return (
		<>
			{listKeysError && <PageAlert message={listKeysError} />}
			<ApiKeyListTop onNewKey={onNewKey} />
			<ApiKeyList onDelete={onDelete} data={listKeysResponse} loading={listKeysLoading} />
            
            <Modal
				title="NEW API KEY"
				width={600}
				visible={keyModalVisible}
                onCancel={() => closeKeyModal()}
                footer={<FormFooter onOK={e => addKey({ name : generatedKeyName, key : generatedKeyData})} onClose={() => closeKeyModal()} okText="Save" />}
			>  
			<ApiKeyModal handleKeyNameChange={handleKeyNameChange} generatedKeyName={generatedKeyName} generatedKey={generatedKeyData} />
			</Modal>           
		</>
	)
}

export default ApiKeys